<template>
  <div class="article" v-loading.fullscreen.lock="loading">
    <div class="article_Breadcrumb">
      <Breadcrumb separator=">">
        <span style="padding:0 10px 0 0">当前位置:&nbsp;&nbsp;</span>
        <BreadcrumbItem to="/home">
          <Icon type="ios-home-outline"></Icon>首页
        </BreadcrumbItem>
        <BreadcrumbItem>全文</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="article_cont" v-html="htmlTxt"></div>
  </div>
</template>
<style lang="less">
.article {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  .article_Breadcrumb {
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #ddd;
  }
  .article_cont {
    width: 90%;
    margin: 20px auto 10px;
    text-indent: 26px;
    line-height: 28px;
    font-size: 14px;
  }
}
</style>
<script>
import { DeclareList } from "@/api/declare/index";
export default {
  data() {
    return {
      loading: false,
      htmlTxt: ""
    };
  },
  created() {
    this.getDeclareList();
  },
  methods: {
    //获取申报项目列表
    getDeclareList() {
      this.loading = true;
      let params = {
        pagesize: 10,
        pageIndex: 1
      };
      DeclareList(params)
        .then(res => {
          let code = this.$route.params.code;
          for (let i = 0; i < res.items.length; i++) {
            if (code == res.items[i].project_code) {
              this.htmlTxt = res.items[i].notes;
              break;
            }
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>